import {z} from 'zod';

export default z.object({
    for_mobile: z.boolean(),
    for_desktop: z.boolean(),
    html_desktop: z.string(),
    html_mobile: z.string(),
    custom_fields: z.any().optional(),
});
